import SpriteSymbol from "../../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "error",
  "use": "error-usage",
  "viewBox": "0 0 22 22",
  "content": "<symbol viewBox=\"0 0 22 22\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"error\">\n    <circle cx=\"11\" cy=\"11\" r=\"11\" fill=\"#FC5555\" />\n    <path d=\"M8 8L14 14\" stroke=\"white\" stroke-width=\"2\" stroke-linecap=\"square\" />\n    <path d=\"M14 8L8 14\" stroke=\"white\" stroke-width=\"2\" stroke-linecap=\"square\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol